<template>
    <div>
        <div>
            <el-form>
                <h1>开关配置</h1>
                <el-form-item label="锁仓开关：" style="padding-top: 10px">
                    <el-switch active-color="#13ce66" inactive-color="#ff4949" @change="canLockEnabled($event)"
                               v-model="configData.canLock"></el-switch>
                </el-form-item>
                <el-form-item label="解锁开关：" style="padding-top: 10px">
                    <el-switch active-color="#13ce66" inactive-color="#ff4949" @change="canUnlockEnabled($event)"
                               v-model="configData.canUnlock"></el-switch>
                </el-form-item>
                <h1>订单数配置</h1>
                <el-form-item label="每日单用户提交锁仓订单数最大上限：" style="padding-top: 10px">
                    <el-input v-model="configData.everyDayCreateLockMax" placeholder="每日单用户提交锁仓订单数最大上限"
                              style="width: 500px">
                        <i slot="suffix">个</i>
                    </el-input>
                </el-form-item>
                <el-form-item label="每日单用户提交解锁订单数最大上限：" style="padding-top: 10px">
                    <el-input v-model="configData.everyDayCreateUnlockMax" placeholder="每日单用户提交锁仓订单数最大上限"
                              style="width: 500px">
                        <i slot="suffix">个</i>
                    </el-input>
                </el-form-item>
                <el-form-item style="padding-top: 10px">
                    <el-button type="primary" @click="orderConfigSave">订单数配置保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'PrimaryConfig',
        components: {},
        data() {
            return {
                configData: {}
            }
        },
        methods: {
            getBaseConfig() {
                api.findBaseConfig().then(({data}) => {
                    this.configData = data;
                });
            },
            canLockEnabled(value) {
                this.$confirm(value ? '是否开启锁仓开关？' : '是否关闭锁仓开关', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateLockSwitch({canLock: value}).then(({data}) => {
                        this.getBaseConfig();
                        this.$message.success('修改成功!');
                    });
                }).catch(() => {
                });
            },
            canUnlockEnabled(value) {
                this.$confirm(value ? '是否开启解锁开关？' : '是否关闭解锁开关', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateUnlockSwitch({canUnlock: value}).then(({data}) => {
                        this.getBaseConfig();
                        this.$message.success('修改成功!');
                    });
                }).catch(() => {
                });
            },
            orderConfigSave() {
                let regNeg = /^[0-9]{1,}$/;
                if (!regNeg.test(this.configData.everyDayCreateLockMax)) {
                    this.$message.success('每日单用户提交锁仓订单数最大上限必须为数字!');
                    return;
                }
                if (!regNeg.test(this.configData.everyDayCreateUnlockMax)) {
                    this.$message.success('每日单用户提交解锁订单数最大上限必须为数字!');
                    return;
                }
                console.log(this.configData)
                this.$confirm('是否修改订单数配置？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateUnlock({
                        everyDayCreateLockMax: this.configData.everyDayCreateLockMax,
                        everyDayCreateUnlockMax: this.configData.everyDayCreateUnlockMax
                    }).then(({data}) => {
                        this.getBaseConfig();
                        this.$message.success('修改成功!');
                    });
                }).catch(() => {
                });
            },
        },
        created() {
            this.getBaseConfig();
        }
    };
</script>

<style lang="less" scoped>

</style>

